module.exports = __webpack_public_path__ + "img/ATF.7da4d14f.svg";